import { HStack, VStack, XButton, XDiv, XImage, XLoading, XScroll, XText, XViewportList, XVPScroll } from "IZOX/_X";
import QTHeader from "./_gears/Second/QTHeader";
import QTRow from "./_gears/Second/QTRow";
import QTFooter from "./_gears/QTFooter";
import _ from "lodash";
// eslint-disable-next-line no-unused-vars
import React, { useEffect, CSSProperties, useState, useCallback, useRef, useLayoutEffect, useImperativeHandle } from "react";
import { Accessor, ColorX, GFunc, LocaleX, ZFunc, ZMath, ZSearch, ZTime } from "IZOX/STATIC";
import normal from "./_style/normal";
import QTFRow from "./_gears/Second/QTFRow";
import QTColumnSet from "./_gears/QTColumnSet";
import QTFRow1 from "./_gears/First/QTFRow1";
import QTHeader1 from "./_gears/First/QTHeader1";
import QTRow1 from "./_gears/First/QTRow1";
import dark from "./_style/dark";
import QTCard from "./_gears/Card/QTCard";
import SimpleSearch from "../SimpleSearch/SimpleSearch";

/**
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * @typedef {import("IZOX/_X/XDiv").xdivparams} xdivparams
 * @typedef {import("IZOX/_X/HStack").hstackparams} hstackparams
 * @typedef {import("IZOX/_X/XText").xtextparams} xtextparams
 * 
 * @typedef {hstackparams & xdivparams & xtextparams} stylesparams
 * @typedef {import("./__typedef/__schema").qtableschema} qtableschema
 * @typedef {import("./__typedef/__qtable").qtableparams} qtableparams
 * 
 * @param {xdivparams & qtableparams} param0 
 * @returns 
 */
function QTable({
  onMounted = null,
  onRowSelected = null,
  docs = [],
  schema = [],
  addOns = {},
  IDAccessor = "_id",
  headerHeight = 30,
  filterHeight = 30,
  footerHeight = 30,
  Styles = {day: normal, night: dark},
  noPagination = false,
  rowsPerPage = 50,
  rowsPerPageOptions = [10, 20, 50, 100, 200, 500],
  renderNoData = undefined,
  loading = false,
  selectBox = false,
  showSelectBoxOnlyHover = true,
  selectBoxShape = "square",
  showRowNumber = true,
  activityIndicator = true,
  showColumnSetter = true,
  rowHeight = 30,
  instantFilter = true,
  showFilterOnLoad = false,
  selectDisabler = (doc, addOns) => false,
  rowColor = undefined,
  serverSidePagination = false,
  onPageChange = null,
  onPageSizeChange = null,
  totalRows = undefined,
  showFooterDesc = true,
  showFooterPagination = true,
  showPageSizeOption = true,
  serverSideFiltering = false,
  onFilterChange = null,
  onFilterApply = null,
  onFilterReset = null,
  inServerSideFilter = false,
  miniIcon = false,
  darkMode = false,
  scrollBarOnLeft = false,
  enterKeyApplyFilter = true,
  defaultColumnWidth = 150,
  selectOnRowClick = true,
  dragableRow = false,
  droppableRow = false,
  onSetDrag = null,
  onRowDrop = null,
  rowParamsAddOns = null,
  onRowPress = null,
  hasRowPress = false,
  enableCardView = false,
  cardViewWidth = 500,
  cardViewRenderer = null,
  cardStyle = {},
  ctrls = null,
  ...others}){

  schema = ZFunc.IfFuncExec(schema, docs, addOns);

  const [curPage, setCurPage] = useState(0);
  const [_rowsPerPage, setRowsPerPage] = useState(rowsPerPage);
  const [selected, setSelected] = useState([]);
  const [showFilter, setShowFilter] = useState(showFilterOnLoad ?? false);
  const [filter, setFilter] = useState({});
  const [sorter, setSorter] = useState({});
  const [showCol, setShowCol] = useState({});
  const [colDirty, setColDirty] = useState(false);
  const [freezeCol, setFreezeCol] = useState(0);
  const ref = useRef(null);
  const vref = useRef(null);
  const s1ref = useRef(null);
  const s2ref = useRef(null);
  const [isDragging, setDragging] = useState(false);
  const [dragDocIDs, setDragDocIDs] = useState([]);
  const [simpleSearchText, setSimpleSearchText] = useState("");

  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  const [hoverRow, setHoverRow] = useState(null);
  const [hoverHeader, setHoverHeader] = useState(false);

  /**new Col width */
  const [cw1, setCw1] = useState(0);
  const [cw2, setCw2] = useState(0);
  const [exW1, setExW1] = useState(0);
  const [exW2, setExW2] = useState(0);
  const [cOverflow, setCOverflow] = useState(false);
  const [passedWidth, setPassedWidth] = useState([]);
  const [maxColWidth, setMaxColWidth] = useState([]);
  const [tOverflow, setTOverflow] = useState(false);
  
  const _styles = darkMode ? Styles.night : Styles.day;

  const [isShift, setShift] = useState(false);
  const [isCtrl, setCtrl] = useState(false);

  useEffect(() => {
    let _exW1 = (showRowNumber 
      || activityIndicator 
      || showColumnSetter ? 30 : 0) 
    + (selectBox ? 30 : 0) + (scrollBarOnLeft ? 4: 0);
    let _exW2 = instantFilter ? 30 : 0;
    setExW1(_exW1);
    setExW2(_exW2);
  }, [showRowNumber, activityIndicator, showColumnSetter, selectBox, instantFilter, scrollBarOnLeft]);
  const calExpectedWidth = useCallback(() => {
    let _vrefWidth = vref?.current?.getBoundingClientRect()?.width;
    let _totalWidth = _vrefWidth - exW1 - exW2;
    let _expectedWidth = 0;
    let noDefWidthCount = 0;
    for(let i=0; i<schema.length; i++){
      let o = schema[i];
      let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(o.hidden ?? false));
      if(!_showCol) continue;
      if(o.width === undefined){
        noDefWidthCount++;
        _expectedWidth += defaultColumnWidth;
      }else{
        _totalWidth -= o.width;
        _expectedWidth += o.width;
      }
    }
    let overflowTable = _vrefWidth < _expectedWidth;
    let defaultWidth = overflowTable ? defaultColumnWidth : (_totalWidth / noDefWidthCount);
    let tableWidth = (overflowTable ? _expectedWidth : _vrefWidth) - exW1 - exW2;
    setTOverflow(overflowTable);
    return {defaultWidth, tableWidth, overflowTable};
  }, [schema, showCol, exW1, exW2, defaultColumnWidth]);

  const calMaxWidth = useCallback((total, pW) => {
    let mW = _.map(schema, o => total);
    let culWidth = 0;
    for(let i=0; i<pW.length; i++){
      mW[i] = total - culWidth;
      culWidth += pW[i];
      let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(schema[i].hidden ?? false));
      if(!_showCol) continue;
      for(let j=i; j<pW.length; j++){
        if(i === j) continue;
        let o = schema[j];
        let {
          minWidth = 50, 
          resizable = _.isUndefined(o.width), 
          width,
          hidden
        } = o;
        let _showColV = Accessor.Get(showCol, `col${j}`) ?? (!(hidden ?? false));
        if(_showColV){
          mW[i] -= resizable ? minWidth : (width ?? pW[j]);
        }
      }
    }
    setMaxColWidth(mW);
  }, [schema, showCol]);

  const refreshWidth = useCallback(() => {
    let {defaultWidth, tableWidth, overflowTable} = calExpectedWidth();
    let _pw = [];
    for(let i=0; i<schema.length; i++){
      let o = schema[i];
      let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(o.hidden ?? false));
      if(!_showCol){
        _pw.push(0);
      }else{
        if(o.width === undefined){
          _pw.push(defaultWidth);
        }else{
          _pw.push(o.width);
        }
      }      
    }
    setCOverflow(overflowTable);
    setPassedWidth(_pw);
    calMaxWidth(tableWidth, _pw);
  }, [schema, showCol, calMaxWidth, calExpectedWidth]);

  useEffect(() => {
    refreshWidth();
  }, [showCol, refreshWidth]);

  useEffect(() => {
    let cw1 = _.reduce(_.slice(schema, 0, freezeCol + 1), (acc, o, i) => {
      let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(o.hidden ?? false));
      if(_showCol){
        acc += passedWidth[i] ?? 150;
      }
      return acc;
    }, 0);
    cw1 += exW1;
  
    let cw2 = _.reduce(_.slice(schema, freezeCol + 1), (acc, o, i) => {
      let _i = freezeCol + 1 + i;
      let _showCol = Accessor.Get(showCol, `col${_i}`) ?? (!(o.hidden ?? false));
      if(_showCol){
        acc += passedWidth[_i] ?? 150;
      }
      return acc;
    }, 0);
    cw2 += exW2;

    setCw1(cw1);
    setCw2(cw2);

  }, [showCol, colDirty, passedWidth, freezeCol, exW1, exW2, schema]);

  const resizeTimeout = useRef(null);

  const optimizedRefreshWidth = useCallback(() => {
    if (resizeTimeout.current) {
      clearTimeout(resizeTimeout.current);
    }
    resizeTimeout.current = setTimeout(() => {
      refreshWidth();
    }, 50); // Delay in ms, adjust as needed
  }, [refreshWidth]);

  useEffect(() => {
    const _vrefCurrent = vref.current;
    window.addEventListener("resize", optimizedRefreshWidth);

    let resizeObserver;
    if (_vrefCurrent) {
      resizeObserver = new window.ResizeObserver(() => {
        optimizedRefreshWidth();
      });
      resizeObserver.observe(_vrefCurrent);
    }

    return () => {
      window.removeEventListener("resize", optimizedRefreshWidth);
      if (resizeObserver && _vrefCurrent) {
        resizeObserver.unobserve(_vrefCurrent);
        resizeObserver.disconnect();
      }
      if (resizeTimeout.current) {
        clearTimeout(resizeTimeout.current);
      }
    };
  }, [optimizedRefreshWidth, vref]);

  /**new Col width END*/
  
  useEffect(() => {

    const _getSelected = () => selected;
    const _setSelected = (selectedDocs) => setSelected(selectedDocs);
    const __setCurPage = (page) => setCurPage(page);

    let callbacks = {
      getSelected: _getSelected,
      setSelected: _setSelected,
      setCurPage: __setCurPage,
      forceUpdate: updateState
    };

    onMounted?.(callbacks);
  }, [onMounted, selected]);

  useImperativeHandle(ctrls, () => ({
    getSelected: () => selected,
    setSelected: (selectedDocs) => setSelected(selectedDocs),
    setCurPage: (page) => setCurPage(page),
    forceUpdate: updateState
  }), [selected]);

  useEffect(() => {
    let lastFreezeCol = _.findLastIndex(schema, o => o.freeze === true);
    setFreezeCol(lastFreezeCol);
  }, [schema]);

  const _setRowsPerPage = (num) => {
    setRowsPerPage(num);
    onPageSizeChange?.(num);
  };

  const toggleSelect = (id, value) => {
    if(value){
      setSelected(prev => {
        let newRows = _.uniq([...prev, id]);
        onRowSelected?.(newRows);
        return newRows;
      });
    }else{
      setSelected(prev => {
        let newRows = _.filter(prev, o => o !== id);
        onRowSelected?.(newRows);
        return newRows;
      });
    }
  };

  const onClickSelect = (id, value) => {
    if(isShift){
      // Clear any accidental browser text highlight from Shift-click
      try{ window.getSelection?.()?.removeAllRanges?.(); }catch{}
      let _docs = _.filter(docs, o => selectDisabler ? !selectDisabler(o, addOns) : true);
      let newRows = _.map(_docs, o => Accessor.Get(o, IDAccessor));
      let _start = _.indexOf(newRows, selected[0]);
      let _end = _.indexOf(newRows, id);
      if(_start > _end){
        let _temp = _start;
        _start = _end;
        _end = _temp;
      }
      let _newRows = _.slice(newRows, _start, _end + 1);
      onRowSelected?.(_newRows);
      setSelected(_newRows);
    }else if(isCtrl || selectBox){
      // With selectBox (bulk select), plain row click toggles instead of replacing selection
      toggleSelect(id, value);
    }else{
      onRowSelected?.([id]);
      setSelected([id]);
    }
  };

  const _onRowPress = useCallback((id, doc) => {
    onRowPress?.(id, doc, {isShift, isCtrl});
  }, [onRowPress, isShift, isCtrl]);

  const toggleSelectAll = (value) => {
    if(value){
      let _docs = _.filter(docs, o => selectDisabler ? !selectDisabler(o, addOns) : true);
      let newRows = _.map(_docs, o => Accessor.Get(o, IDAccessor));
      onRowSelected?.(newRows);
      setSelected(newRows);
    }else{
      onRowSelected?.([]);
      setSelected([]);
    }
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const reCal = useCallback((prevPW, index, sWidth) => {
    let {tableWidth} = calExpectedWidth();
    let newPW = [...prevPW];
    let oriWidth = tableWidth;
    let diff = prevPW[index] - sWidth;
    newPW[index] = sWidth;
  
    if(diff < 0){
      //shrink others
      diff = Math.abs(diff);
      for(let i = index + 1; i < prevPW.length; i++){
        let {minWidth, hidden, resizable = _.isUndefined(schema[i].width)} = schema[i];
        let _minWidth = minWidth ?? 50;
        let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(hidden ?? false));
        if(!_showCol || !resizable) continue;
        if(_minWidth > prevPW[i] - diff){
          diff = diff - (prevPW[i] - _minWidth);
          newPW[i] = _minWidth;
        }else{
          newPW[i] = prevPW[i] - diff;
          diff = 0;
          break;
        }
      }        
    }else{
      //enlarge others
      for(let i = index + 1; i < prevPW.length; i++){
        let {maxWidth, hidden, resizable = _.isUndefined(schema[i].width)} = schema[i];
        let _maxWidth = maxWidth ?? Number.MAX_SAFE_INTEGER;
        let _showCol = Accessor.Get(showCol, `col${i}`) ?? (!(hidden ?? false));
        if(!_showCol || !resizable) continue;
        if(_maxWidth < prevPW[i] + diff){
          diff = diff - (prevPW[i] - _maxWidth);
          newPW[i] = _maxWidth;
        }else{
          newPW[i] = prevPW[i] + diff;
          diff = 0;
          break;
        }
      }
      if(diff > 0){
        newPW[index] += diff;
      }
    }

    setPassedWidth(newPW);
    calMaxWidth(oriWidth, newPW);
    setColDirty(true);
  }, [schema, calMaxWidth, calExpectedWidth, showCol]);

  const _onRectSet = useCallback((index, sWidth) => {
    let prevPW = [...passedWidth];
    reCal(prevPW, index, sWidth);
  }, [passedWidth, reCal]);

  useLayoutEffect(() => {
    setColDirty(true);
    forceUpdate();
  }, [vref, forceUpdate]);

  useEffect(() => {
    setColDirty(true);
    forceUpdate();
  }, [vref, forceUpdate]);

  const _onScroll = (e) => {
    s1ref.current.scrollTop = e.target.scrollTop;
    s2ref.current.scrollTop = e.target.scrollTop;
  };

  const _onFilterApply = () => {
    if(!serverSideFiltering) return;
    _setCurPage(0, true);
    onFilterApply?.(filter);
  };

  const _onFilterReset = () => {
    if(!serverSideFiltering) return;
    setFilter({});
    onFilterReset?.();
  };

  const _onShowColSet = useCallback((_s) => {
    setShowCol(_s);
    refreshWidth();
  }, [refreshWidth]);

  const _onColumnSet = (e) => {
    let rect = ref.current.getBoundingClientRect();
    GFunc.SelectorOverlay(() => {
      return (
        <VStack position="absolute"
          style={{
            top: rect.bottom,
            left: rect.left
          }} noPropagation>
          <QTColumnSet schema={schema} showCol={showCol} darkMode={darkMode} 
            setShowCol={_onShowColSet}/>
        </VStack>
      );
    }, {}, true, false, true);
  };

  const _onSimpleSearchTextChange = (text) => {
    setSimpleSearchText(text);
    let _s = _.find(schema, o => o.forSimpleSearch);
    let {name, filterFormat, filterComparer, filterValue, Cell} = _s;
    filter[name] = {val: text, filterFormat, filterComparer, filterValue, Cell};
    setFilter(filter ?? {});
    onFilterChange?.(filter);
    forceUpdate();
  };
  
  /**
   * 
   * @param {qtableschema} schema 
   * @param {*} val 
   */
  const onFilterTextChange = (_schema, val) => {
    let {name, filterFormat, filterComparer, filterValue, Cell, oper, format, multiple} = _schema;
    filter[name] = {val, filterFormat, filterComparer, filterValue, Cell, oper, format, multiple};
    setFilter(filter ?? {});
    onFilterChange?.(filter);
    forceUpdate();
  };

  const onFilterClear = (name) => {
    delete filter[name];
    setFilter(filter ?? {});
    onFilterChange?.(filter);
    if(enterKeyApplyFilter){
      if(_.isEmpty(filter)){
        _onFilterReset?.();
      }else{
        _onFilterApply?.(filter);
      }
    } 
    forceUpdate();
  };

  const onSortChange = (name) => {
    let _sort = sorter[name];
    if(!_sort){
      sorter[name] = "asc";
    }else if(_sort === "asc"){
      sorter[name] = "desc";
    }else{
      delete sorter[name];
    }
    setSorter(sorter);
    forceUpdate();
  };

  const FilterDocs = (_docs, _filter) => {
    _.map(_filter, (o, i) => {
      let {val, filterFormat, filterComparer, filterValue, ValueMod, Cell} = o;
      _docs = _.filter(_docs, v => {
        let value = (filterValue ?? ValueMod ?? Cell)?.(v, Accessor.Get(v, i), addOns) ?? Accessor.Get(v, i);
        if(!_.isNumber(value) && !_.isBoolean(value) && !_.isString(value) && React.isValidElement(value)){
          value = String(value);
        }
        if(!_.isNumber(val) && !_.isBoolean(val) && _.isEmpty(val)) return true;
        if(filterComparer){
          return filterComparer?.(value, val, v, addOns);
        }else{
          if(filterFormat === "date"){
            return ZTime.IsBetween(value, val?.start, val?.end);
          }else if(filterFormat === "bool"){
            return value === val;
          }else{
            return ZSearch.GetAllLangValues(value).includes(val?.toLowerCase?.() ?? val);
          }
        }
      });
    });
    return _docs;
  };

  const SortDocs = (_docs, _sorter, _schema) => {
    if(_.isEmpty(_sorter)) return _docs;

    let _names = _.map(_sorter, (o, i) => {
      let _s = _.find(_schema, v => v.name === i);
      let _sortComparer = _s?.sortComparer;
      if(_sortComparer) {
        return (doc) => {
          let field = Accessor.Get(doc, i);
          return _sortComparer(_docs, field, addOns);
        };
      }else if(_s.format === "lang"){
        return (doc) => {
          let field = Accessor.Get(doc, i);
          return field?.EN ?? field?.TC ?? "";
        };
      }
      return i;
    });
    let _order = _.map(_sorter, (o, i) => o);
    _docs = _.orderBy(_docs, _names, _order);
    return _docs;
  };

  let _fDocs = [], _sDocs = [];
  if(!serverSideFiltering && showFilter){
    _fDocs = FilterDocs(docs, filter);
  }else{
    _fDocs = docs;
  }

  _sDocs = SortDocs(_fDocs, sorter, schema);

  let rpp = _rowsPerPage;
  if(noPagination){
    rpp = Infinity;
  }

  totalRows = serverSidePagination ? totalRows : _sDocs.length;
  let totalPages = noPagination ? 1 : Math.ceil(totalRows / rpp);

  let startRow = noPagination ? 0 : rpp * curPage;
  let endRow = noPagination ? totalRows - 1 : ZMath.Cap(rpp * (curPage + 1) - 1, 0, totalRows - 1);
  let displayDocs = serverSidePagination ? _sDocs : _.slice(_sDocs, startRow, endRow + 1);
  let isSelectedAll = _sDocs.length > 0 && _.every(_sDocs, o => {
    return (selectDisabler ? selectDisabler(o, addOns) : false)
      || selected.includes(Accessor.Get(o, IDAccessor));
  });

  const _setCurPage = useCallback((page, preventRefresh = false) => {
    page = ZMath.Cap(page, 0, totalPages - 1);
    setCurPage(page);
    onPageChange?.(page, preventRefresh);
  }, [totalPages, onPageChange]);

  //#region Key Controll
  const onKeyDown = useCallback((e) => {
    if(e.ctrlKey){setCtrl(true);}
    if(e.shiftKey){setShift(true);}
    if(e.key === "ArrowLeft" && e.target === document.body){
      _setCurPage(curPage - 1);
    }
    if(e.key === "ArrowRight" && e.target === document.body){
      _setCurPage(curPage + 1);
    }
  }, [curPage, _setCurPage]);

  const onKeyUp = useCallback((e) => {
    setCtrl(false);
    setShift(false);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("keyup", onKeyUp);
    };
  }, [onKeyUp, onKeyDown]);
  //#endregion Key Controll

  //#region Drag Row

  const _onRowDragStart = (docID) => {
    if(selected.includes(docID)){
      setDragging(true);
      setDragDocIDs(selected);
      onSetDrag?.(selected);
    }else{
      setDragging(true);
      setDragDocIDs([docID]);
      onSetDrag?.([docID]);
    }
  };

  const _onRowDrop = (docID, e) => {
    setDragging(false);
    onRowDrop?.(dragDocIDs, docID, e);
    setSelected([]);
    setDragDocIDs([]);
  };

  //#endregion Drag Row

  function renderMain(){
    if(displayDocs.length > 0){
      return (
        <XViewportList viewportRef={s2ref} items={displayDocs} overscan={10}>
          {(o, i) => {
            let ID = Accessor.Get(o, IDAccessor);
            return (
              <QTRow schema={schema} doc={o} key={ID} Styles={_styles} 
                _passedWidth={passedWidth} 
                docID={ID}
                freezeCol={freezeCol}
                darkMode={darkMode}
                addOns={addOns} startRow={startRow} rowIdx={i} 
                selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
                selectBoxShape={selectBoxShape}
                selected={selected}
                activityIndicator={activityIndicator} showRowNumber={showRowNumber}
                _toggleSelect={toggleSelect} instantFilter={instantFilter}
                _onClickSelect={onClickSelect}
                onRowPress={_onRowPress}
                hasRowPress={hasRowPress}
                rowColor={rowColor} showCol={showCol}
                rowHeight={rowHeight} selectDisabler={selectDisabler}
                setHoverRow={setHoverRow}
                isHover={hoverRow === ID}
                selectOnRowClick={selectOnRowClick}
                dragableRow={dragableRow}
                droppableRow={droppableRow}
                _onRowDragStart={_onRowDragStart}
                _onRowDrop={_onRowDrop}
                rowParamsAddOns={rowParamsAddOns}
                isDragging={isDragging}
                ID={ID}
                />
            );
          }}
        </XViewportList>
      );
    }else{
      return (renderNoData?.() ??
        <VStack fullHeight fullWidth VAlign="-">
          <XImage source="/Images/NoFileFound.svg" width={100} opacity={0.1}/>
        </VStack>
      );
    }
  }

  function renderHeader(){
    return (
      <XDiv fullWidth height={headerHeight} flexWrap="nowrap"
        {..._styles.headerContainer}>
        <QTHeader schema={schema} addOns={addOns} _onRectSet={_onRectSet} 
          freezeCol={freezeCol}
          darkMode={darkMode}
          Styles={_styles} loading={loading} 
          selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
          selectBoxShape={selectBoxShape}
          isSelectedAll={isSelectedAll}
          activityIndicator={activityIndicator} showRowNumber={showRowNumber}
          _toggleSelectAll={toggleSelectAll} selected={selected}
          _toggleFilter={toggleFilter}
          instantFilter={instantFilter}
          showFilter={showFilter} 
          onSortChange={onSortChange}
          showCol={showCol}
          colDirty={colDirty}
          sorter={sorter}
          _passedWidth={passedWidth}
          maxColWidth={maxColWidth}
          hoverHeader={hoverHeader}
          setHoverHeader={setHoverHeader}/>
      </XDiv>
    );
  }

  function renderFilter(){
    if(!instantFilter) return;
    return (
      <XDiv fullWidth flexWrap="nowrap"
        {..._styles.headerContainer}
        style={{
          ..._styles.headerContainer.style, 
          maxHeight: showFilter ? headerHeight : 0, 
          transition: "max-height 0.5s"
        }}>
        <QTFRow schema={schema} addOns={addOns}
          freezeCol={freezeCol}
          darkMode={darkMode}
          Styles={_styles} loading={loading} 
          selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
          selectBoxShape={selectBoxShape}
          activityIndicator={activityIndicator}
          instantFilter={instantFilter} 
          selected={selected}
          showRowNumber={showRowNumber}
          showFilter={showFilter}
          isSelectedAll={isSelectedAll}
          filterHeight={filterHeight}
          _toggleSelectAll={toggleSelectAll} 
          _toggleFilter={toggleFilter}
          _onFilterTextChange={onFilterTextChange}
          _onFilterClear={onFilterClear}
          _onColumnSet={_onColumnSet}
          filter={filter}
          _onFilterApply={_onFilterApply}
          serverSideFiltering={serverSideFiltering}
          inServerSideFilter={inServerSideFilter}
          _onFilterReset={_onFilterReset}
          enterKeyApplyFilter={enterKeyApplyFilter}
          miniIcon={miniIcon}
          showCol={showCol}
          _passedWidth={passedWidth}/>
      </XDiv>
    );
  }

  //#region Freeze Col
  function renderMain1(){
    if(displayDocs.length > 0){
      return (
        <XViewportList viewportRef={s1ref} items={displayDocs} overscan={10}>
          {(o, i) => {
            let ID = Accessor.Get(o, IDAccessor);
            return (
            <QTRow1 schema={schema} doc={o} key={ID} Styles={_styles} 
              _passedWidth={passedWidth} 
              docID={ID}
              freezeCol={freezeCol}
              darkMode={darkMode}
              addOns={addOns} startRow={startRow} rowIdx={i} 
              selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
              selectBoxShape={selectBoxShape} 
              selected={selected}
              showColumnSetter={showColumnSetter}
              activityIndicator={activityIndicator} showRowNumber={showRowNumber}
              _toggleSelect={toggleSelect} 
              _onClickSelect={onClickSelect}
              onRowPress={_onRowPress}
              hasRowPress={hasRowPress}
              instantFilter={instantFilter}
              rowColor={rowColor} showCol={showCol}
              rowHeight={rowHeight} selectDisabler={selectDisabler}
              setHoverRow={setHoverRow}
              isHover={hoverRow === ID}
              selectOnRowClick={selectOnRowClick}
              dragableRow={dragableRow}
              _onRowDragStart={_onRowDragStart}
              _onRowDrop={_onRowDrop}
              rowParamsAddOns={rowParamsAddOns}
              isDragging={isDragging}
              ID={ID}
              />
            );
          }}
        </XViewportList>
      );
    }else{
      return (renderNoData?.() ??
        <VStack fullHeight fullWidth VAlign="-">
          
        </VStack>
      );
    }
  }

  function renderHeader1(){
    return (
      <XDiv fullWidth height={headerHeight} flexWrap="nowrap"
        {..._styles.headerContainer}>
        <QTHeader1 schema={schema} addOns={addOns} _onRectSet={_onRectSet} 
          freezeCol={freezeCol}
          darkMode={darkMode}
          Styles={_styles} loading={loading} 
          selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
          selectBoxShape={selectBoxShape}
          isSelectedAll={isSelectedAll}
          activityIndicator={activityIndicator} showRowNumber={showRowNumber}
          _toggleSelectAll={toggleSelectAll} selected={selected}
          _toggleFilter={toggleFilter}
          instantFilter={instantFilter}
          showFilter={showFilter} 
          onSortChange={onSortChange}
          showCol={showCol}
          colDirty={colDirty}
          sorter={sorter}
          _passedWidth={passedWidth}
          maxColWidth={maxColWidth}
          hoverHeader={hoverHeader}
          setHoverHeader={setHoverHeader}/>
      </XDiv>
    );
  }

  function renderFilter1(){
    if(!instantFilter) return;
    return (
      <XDiv fullWidth flexWrap="nowrap"
        {..._styles.headerContainer}
        style={{
          ..._styles.headerContainer.style, 
          maxHeight: showFilter ? headerHeight : 0, 
          transition: "max-height 0.5s"
        }}>
        <QTFRow1 schema={schema} addOns={addOns} forwardRef={ref}
          freezeCol={freezeCol}
          darkMode={darkMode}
          Styles={_styles} loading={loading} 
          selectBox={selectBox} showSelectBoxOnlyHover={showSelectBoxOnlyHover}
          selectBoxShape={selectBoxShape}
          activityIndicator={activityIndicator}
          instantFilter={instantFilter} 
          selected={selected}
          showRowNumber={showRowNumber}
          showColumnSetter={showColumnSetter}
          showFilter={showFilter}
          isSelectedAll={isSelectedAll}
          filterHeight={filterHeight}
          _toggleSelectAll={toggleSelectAll} 
          _toggleFilter={toggleFilter}
          _onFilterTextChange={onFilterTextChange}
          _onFilterClear={onFilterClear}
          _onColumnSet={_onColumnSet}
          filter={filter}
          _onFilterApply={_onFilterApply}
          serverSideFiltering={serverSideFiltering}
          inServerSideFilter={inServerSideFilter}
          _onFilterReset={_onFilterReset}
          enterKeyApplyFilter={enterKeyApplyFilter}
          miniIcon={miniIcon}
          showCol={showCol}
          _passedWidth={passedWidth}/>
      </XDiv>
    );
  }
  function renderSSFBlock(){
    return (
      <HStack spacing={5} pV={2} pH={10} HAlign="[">
        <XDiv height={30}/>
      </HStack>
    );
  }

  //#endregion Freeze Col

  function renderSSFBtn(_cw1){
    return (
      <HStack spacing={5} pV={2} pH={10} HAlign="[" mL={-_cw1}
        bColor={ColorX.CSS("lightGrey")} lockHeight={30} mB={4}>
        <XDiv height={25} width={_cw1} flexShrink={0}/>
        <HStack HAlign="[" spacing={10}>
          <XButton onPress={_onFilterReset} padding={0} pH={5} round={50} bW={2} notInjectColor lockHeight={23}
            {...(inServerSideFilter ? _styles.inSSFReset : _styles.notSSFReset)}>
            <HStack>
              <XText lineHeight={1.1} textAlign="|" fontSize={10}
              {...(inServerSideFilter ? _styles.inSSFResetText : _styles.notSSFResetText)}>
                {LocaleX.Parse({EN: "Reset Filter", TC: "重置篩選"})}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={_onFilterApply} padding={0} pH={5} round={50} bW={2} notInjectColor lockHeight={23}
            {...(inServerSideFilter ? _styles.inSSFApply : _styles.notSSFApply)}
            >
            <HStack>
              <XText lineHeight={1.1} textAlign="|" fontSize={10}
                {...(inServerSideFilter ? _styles.inSSFApplyText : _styles.notSSFApplyText)}>
                {LocaleX.Parse({EN: "Apply Filter", TC: "套用篩選"})}
              </XText>
            </HStack>
          </XButton>
          <HStack fitWidthToContent p={5}>
            <XText color={ColorX.CSS("greyOut")} italic noSelect fontSize={10} noWrap>
              {LocaleX.Parse({EN: "... or press Enter to apply", TC: "... 或按 Enter 鍵套用"})}
            </XText>
          </HStack>
        </HStack>
      </HStack>
    );
  }

  function renderFooter(){
    if(noPagination) return;
    return (
      <XDiv flexWrap="nowrap" height={footerHeight} flexShrink={0}
        {..._styles.footerContainer}>
        <QTFooter addOns={addOns} Styles={_styles}
          darkMode={darkMode}
          curPage={curPage}
          startRow={startRow}
          endRow={endRow}
          _setCurPage={_setCurPage}
          _setRowsPerPage={_setRowsPerPage}
          _rowsPerPage={rpp}
          totalPages={totalPages}
          totalRows={totalRows}
          rowsPerPageOptions={rowsPerPageOptions}
          showFooterDesc={showFooterDesc}
          showPageSizeOption={showPageSizeOption}
          showFooterPagination={showFooterPagination}/>
      </XDiv>
    );
  }

  function renderCardCore(){
    return (
      <VStack fullWidth flexGrow={1} flexShrink={1}>
        <SimpleSearch onChangeText={_onSimpleSearchTextChange}
          onEnterKeyDown={_onFilterApply}
          onApply={_onFilterApply}
          showApplyButton={serverSideFiltering}
          searchText={simpleSearchText}/>
        <XVPScroll fullWidth flexGrow={1} flexShrink={1} items={displayDocs} p={10}>
          {(o, i) => {
            let docID = Accessor.Get(o, IDAccessor);
            let isSelected = selected.includes(docID);
            return cardViewRenderer?.({
                doc: o, 
                docID,
                schema,
                addOns,
                isSelected,
                onRowPress,
                selectOnRowClick,
                _onClickSelect: onClickSelect,
                cardStyle,
                darkMode
              }) ?? <QTCard doc={o} docID={docID} 
                rowIdx={i}
                startRow={startRow}
                Styles={_styles}
                schema={schema} key={i}
                onRowPress={_onRowPress}
                isSelected={isSelected}
                selectOnRowClick={selectOnRowClick}
                _onClickSelect={onClickSelect}
                darkMode={darkMode}
                cardStyle={cardStyle}
                addOns={addOns}/>;
          }}
        </XVPScroll>
      </VStack>
    );
  }

  function renderCore(){
    return (
      <HStack fullHeight>
        <VStack minWidth={cw1} maxWidth={cw1} fullHeight HAlign="[">
          {renderHeader1()}
          {renderFilter1()}
          {showFilter && !miniIcon && serverSideFiltering && renderSSFBlock()}
            <XScroll flexGrow={1} flexBasis={1} {..._styles.body}
              forwardRef={s1ref} onScroll={_onScroll} masked={false}
              mB={!scrollBarOnLeft && tOverflow ? 4 : 0}
              style={{
                scrollbarWidth: scrollBarOnLeft ? "auto" : "none",
              }}>
              <XLoading loading={loading} containerRef={vref} darkMode={darkMode}/>
              {renderMain1()}
            </XScroll>
        </VStack>
        <XScroll fullWidth fullHeight masked={false}>
          <VStack minWidth={cOverflow ? cw2: undefined} maxWidth={cOverflow ? cw2: undefined}  fullHeight HAlign="[">
            {renderHeader()}
            {renderFilter()}
            {showFilter && !miniIcon && serverSideFiltering && renderSSFBtn(cw1)}
            <XScroll flexGrow={1} flexBasis={1} {..._styles.body} masked={false}
              forwardRef={s2ref} onScroll={_onScroll}>
              {renderMain()}
            </XScroll>
          </VStack>
        </XScroll>
      </HStack>
    );
  }

  function MainSwitch(){
    let _vrefWidth = vref?.current?.getBoundingClientRect()?.width;
    if(enableCardView && _vrefWidth < cardViewWidth){
      return renderCardCore();
    }else{
      return renderCore();
    }
  }



  return (
    <VStack {..._styles.table} {...others} colorTransition forwardRef={vref}
      // bgColor={ColorX.CSS(darkMode ? "dmBgDark" : "pureWhite")}
      onMouseEnter={() => setHoverRow(null)}>
      {MainSwitch()}
      {renderFooter()}
    </VStack>
  );
}

export default QTable;